import { RegionKeys } from 'src/core/provider/AppMeta';

export default class SuccessListOverview {
    public readonly countryIso2: RegionKeys | 'all';
    public readonly openBPContactsCount: number;
    public readonly openBPDecisionsCount: number;
    public readonly openCustomerContactsCount: number;
    public readonly openCustomerDecisionsCount: number;
    public readonly customerClosedCount: number;
    public readonly totalContactsCount: number;
    public readonly bpclosedCount: number;

    constructor(json: any) {
        this.countryIso2 = json.countryIso2;
        this.openBPContactsCount = json.openBPContactsCount;
        this.openBPDecisionsCount = json.openBPDecisionsCount;
        this.openCustomerContactsCount = json.openCustomerContactsCount;
        this.openCustomerDecisionsCount = json.openCustomerDecisionsCount;
        this.customerClosedCount = json.customerClosedCount;
        this.totalContactsCount = json.totalContactsCount;
        this.bpclosedCount = json.bpclosedCount;
    }
}
